/* eslint-disable @typescript-eslint/unbound-method, @typescript-eslint/no-unsafe-assignment */
import { AxiosResponse } from 'axios';
import { UserDocumentWithAccess } from '@youscience/bpa-common';

import { PreferredAccess } from '@interfaces/user';

import { GUS_API_ENDPOINT } from '@constants/externalRoutes';

import { Api } from './api.service';

class AuthService extends Api {
  constructor() {
    super({
      withCredentials: true,
      baseURL: GUS_API_ENDPOINT,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
  }

  public getUser = (): Promise<void | UserDocumentWithAccess> => {
    return this.get<UserDocumentWithAccess, AxiosResponse<UserDocumentWithAccess>>('/me', {
      params: { includeCards: true },
    })
      .then(this.success)
      .catch(this.error);
  };

  public getUserPreferences = (): Promise<void | PreferredAccess> => {
    return this.get<PreferredAccess, AxiosResponse<PreferredAccess>>('/me/preferences')
      .then(this.success)
      .catch(this.error);
  };

  public updateUserPreferences = (preferredAccess: PreferredAccess): Promise<void | PreferredAccess> => {
    return this.patch<PreferredAccess, PreferredAccess, AxiosResponse<PreferredAccess>>(
      '/me/preferences',
      preferredAccess,
    )
      .then(this.success)
      .catch(this.error);
  };
}

export const authService = new AuthService();
